import type { PrescriptionAnalysisStatus } from '@/types';

/** Read at request time (SSR). Do not use for gating SSG pages. */
export function getPrescriptionAnalysisEnabled(): boolean {
  return process.env.NEXT_PUBLIC_PRESCRIPTION_ANALYSIS_ENABLED === 'true';
}

/** Build-time snapshot; prefer `getPrescriptionAnalysisEnabled()` on the server. */
export const isPrescriptionAnalysisEnabled = getPrescriptionAnalysisEnabled();

/** Default 50 MB — keep in sync with API PRESCRIPTION_ANALYSIS_DEFAULT_MAX_FILE_BYTES. */
const DEFAULT_PRESCRIPTION_ANALYSIS_MAX_FILE_BYTES = 50 * 1024 * 1024;

/** Client-side cap (bytes). Override with NEXT_PUBLIC_PRESCRIPTION_ANALYSIS_MAX_FILE_BYTES. */
export const PRESCRIPTION_ANALYSIS_MAX_FILE_BYTES = process.env
  .NEXT_PUBLIC_PRESCRIPTION_ANALYSIS_MAX_FILE_BYTES
  ? Number(process.env.NEXT_PUBLIC_PRESCRIPTION_ANALYSIS_MAX_FILE_BYTES)
  : DEFAULT_PRESCRIPTION_ANALYSIS_MAX_FILE_BYTES;

export const PRESCRIPTION_ANALYSIS_ACCEPTED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
] as const;

export const PRESCRIPTION_ANALYSIS_ACCEPT =
  'image/jpeg,image/png,application/pdf';

export const PRESCRIPTION_ANALYSIS_POLL_INTERVAL_MS = 2000;

export const PRESCRIPTION_ANALYSIS_POLL_TIMEOUT_MS = 3 * 60 * 1000;

export const PRESCRIPTION_ANALYSIS_STATUS_LABELS: Record<
  PrescriptionAnalysisStatus,
  string
> = {
  uploading: 'Enviando receita',
  extracting: 'Extraindo medicamentos',
  matching: 'Buscando produtos',
  completed: 'Análise concluída',
  failed: 'Análise falhou',
};

export const PRESCRIPTION_MATCH_TYPE_LABELS: Record<string, string> = {
  exact: 'Correspondência aproximada',
  same_drug_different_dosage: 'Mesmo medicamento, dosagem diferente',
  same_drug_different_form: 'Mesmo medicamento, forma diferente',
  same_drug_different_packaging: 'Mesmo medicamento, embalagem diferente',
  name_only: 'Apenas pelo nome',
  no_match: 'Sem correspondência',
};

export const PRESCRIPTION_ANALYSIS_STEPS = [
  { id: 'upload', label: 'Enviar receita' },
  { id: 'analyzing', label: 'Analisar receita' },
  { id: 'products', label: 'Selecionar medicamentos' },
  { id: 'ownership', label: 'Dados da receita' },
  { id: 'review', label: 'Revisão' },
] as const;
